export enum FormActionYerEnum {
  list = "List",
  listItem = "ListItem",
  custom = "Custom",
  detay = "Detay",
  tab = 'Tab',
  detayList = 'DetayList',
  listTab = 'ListTab',
  bottom = 'Bottom',


}
